module.exports = __webpack_public_path__ + "static/media/icon-settings-salesforce.1aba95d7.svg";